import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import { CatalogItem as Item, Resource } from "../../app/backendTypes";
import { SetCatalog } from "./SetCatalog";
import { RemoveCatalog } from "./RemoveCatalog";
import Avatar from "../common/Avatar";
import SupportCard from "../common/support/SupportCard";
import CatalogAccessCard from "./CatalogAccessCard";

import { useAppSelector, useContract, useUser } from "../../app/hooks";
import { ContractDetails } from "../tools/Tool";

export default function CatalogItem(props: {
  item: Item;
  callback: () => void;
  isAdminOrEditor: boolean;
}) {
  const { item, callback, isAdminOrEditor } = props;

  const userId = useAppSelector((state) => state.auth.userId);
  const { user } = useUser(userId);

  const { contract } = useContract(item.contract_id?.toString());

  return (
    <>
      {isAdminOrEditor && (
        <Box sx={{ display: "flex", gap: 2 }}>
          <SetCatalog callback={() => callback()} item={item} />

          <RemoveCatalog catalog={item} callback={callback} />
        </Box>
      )}

      <Box sx={{ display: "flex", gap: 2 }}>
        <Avatar
          alt={item.info.display_name || contract?.name || ""}
          src={item.info.avatar || contract?.avatar}
        />
        <Typography variant="h4">
          {item.info.display_name || contract?.name}
        </Typography>
      </Box>

      <Card sx={{ width: "100%", maxWidth: "sm" }}>
        <CardHeader
          title={item.info.short_desc || contract?.short_desc}
          slotProps={{ title: { color: "primary" } }}
        />
        <CardContent>
          <Typography>{item.info.long_desc || contract?.long_desc}</Typography>

          {item.info.links.main &&
            (item.mim_group_id === null || item.mim_group_id === "") && (
              <>
                <br />

                <Typography>
                  <a
                    href={item.info.links.main}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.info.links.main}
                  </a>
                </Typography>
              </>
            )}

          <br />

          <Typography>
            <Typography component="span" color="text.secondary">
              Pricing:{" "}
            </Typography>
            {item.info.pricing.desc || contract?.pricing}
          </Typography>

          {contract?.how_to_order && contract?.how_to_order !== "" && (
            <>
              <br />

              <Typography>
                <Typography component="span" color="text.secondary">
                  How to Order:{" "}
                </Typography>
                {contract.how_to_order}
              </Typography>
            </>
          )}
        </CardContent>
      </Card>

      {user !== null &&
        item.mim_group_id !== null &&
        item.mim_group_id !== "" && (
          <CatalogAccessCard
            resource={
              {
                kind: "Catalog",
                inner: {
                  id: item.id,
                  name: item.info.display_name,
                },
              } as Resource
            }
            user={user}
            resourceLink={item.info.links.main}
          />
        )}

      {user !== null && (
        <SupportCard
          resource={
            {
              kind: "Catalog",
              inner: {
                id: item.id,
                name: item.info.display_name || contract?.name,
              },
            } as Resource
          }
          user={user}
        />
      )}

      {contract !== null && <ContractDetails contract={contract} />}
    </>
  );
}
